import React from 'react';
import { useDispatch } from 'react-redux';
import { BaseTable } from 'modules/proposals';
import { IS_DEVELOPMENT } from 'constants/common';
import { Proposal } from '@trnsact/trnsact-shared-types';
import { NetworkStatus, useQuery } from '@apollo/client';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { GET_PROPOSALS_TABLE_DATA } from '../../api';
import { ProposalsTableDataResponse, ProposalsTableDataVariables } from '../../api/types';
import { deskingActions } from '../../model';

interface Props {
  voId: string;
  vendorGUID: string;
}

export const ProposalsTable = ({ vendorGUID, voId }: Props) => {
  const dispatch = useDispatch();

  const { data, loading, networkStatus } = useQuery<ProposalsTableDataResponse, ProposalsTableDataVariables>(
    GET_PROPOSALS_TABLE_DATA,
    {
      skip: !voId,
      variables: { voId },
      nextFetchPolicy: 'cache-first',
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
    }
  );

  const getProposalLink = (proposal: Proposal) => {
    window.open(
      `https://app${
        IS_DEVELOPMENT ? '.dev' : ''
      }.trnsact.com/ps/?vendorGUID=${vendorGUID}&proposalId=${proposal.id}&viewOnly=true`,
      '_blank'
    );
  };

  const handleGoToProposal = (proposal: Proposal) => {
    window.open(`/proposalDetail/${proposal.id}?from=/vo/${voId}`, '_blank');
  };

  const handleEditProposal = (proposal: Proposal) => {
    dispatch(deskingActions.resetStructureAndMenuOptions());
    dispatch(deskingActions.setProposalDetailsForEdit({ id: proposal.id!, saleType: proposal.saleType! }));
  };

  return (
    <CardContainer title="Proposals">
      <BaseTable
        onEditProposal={handleEditProposal}
        onGoToProposal={handleGoToProposal}
        onGoToProposalDetail={getProposalLink}
        tableData={(data?.proposals as any) ?? []}
        loading={loading || networkStatus === NetworkStatus.refetch}
      />
    </CardContainer>
  );
};
